import { TILING_SPINNY_TEXTURE } from "@/components/RenderedDie/components/Node/materials/materialTextures";
import {
  MeshStandardMaterial,
  RepeatWrapping,
  TextureLoader,
  type WebGLProgramParametersWithUniforms,
} from "three";

export const getTilingSpinnyMaterial = (
  maxAnisotropy: number,
  onBeforeCompile?: (shader: WebGLProgramParametersWithUniforms) => void,
) => {
  const tilingSpinnyTexture = new TextureLoader().load(TILING_SPINNY_TEXTURE);
  tilingSpinnyTexture.flipY = false;
  tilingSpinnyTexture.colorSpace = "srgb";
  tilingSpinnyTexture.anisotropy = maxAnisotropy;
  tilingSpinnyTexture.wrapS = tilingSpinnyTexture.wrapT = RepeatWrapping;

  const material = new MeshStandardMaterial({
    map: tilingSpinnyTexture,
    transparent: true,
  });

  material.onBeforeCompile = (shader) => {
    // how fast the texture scrolls
    shader.uniforms.u_Float = { value: -2.0 };
    shader.uniforms.iGlobalTime = { value: 0.0 };

    const uvParsVertex = "#include <uv_pars_vertex>";
    shader.vertexShader = shader.vertexShader.replace(
      uvParsVertex,
      `
        ${uvParsVertex}
        uniform float u_Float;
        uniform float iGlobalTime;
      `,
    );

    const uvVertex = "#include <uv_vertex>";
    shader.vertexShader = shader.vertexShader.replace(
      uvVertex,
      `
        ${uvVertex}
        #ifdef USE_MAP
          vMapUv.x += u_Float * iGlobalTime;
        #else
          vUv.x += u_Float * iGlobalTime;
        #endif
      `,
    );

    onBeforeCompile?.(shader);
  };

  return material;
};
